import { PrimaryButton } from "@digipost/dds-buttons-react";
import { FC, useState } from "react";
import { useNavigate } from "react-router";

import { useTranslate } from "../infrastructure/hooks/useTranslate";
import styles from "./EpostVerifisering.module.less";

export const EpostVerifisering: FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  const verifyEmail = async (): Promise<void> => {
    setLoading(true);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get("token");

    fetch(`/post/api/private/emailVerification/${token}`, {
      method: "POST",
    })
      .then((response) => {
        if (response.ok) {
          navigate("./fullfort");
        } else {
          navigate("./feilet");
        }
      })
      .catch((response) => {
        navigate("./feilet", {
          state: {
            error: response,
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <h1>{translate("verify.header")}</h1>
      <div className={styles.verificationButton}>
        <PrimaryButton onClick={verifyEmail} disabled={loading}>
          {translate("verify.button")}
        </PrimaryButton>
      </div>
    </>
  );
};
